import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/file-image': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M369.9 97.9L286 14C277 5 264.8-0.1 252.1-0.1H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V131.9C384 119.2 378.9 106.9 369.9 97.9zM332.1 128H256V51.9L332.1 128zM48 464V48H208V152C208 165.3 218.7 176 232 176H336V464H48zM80 416H304V288L280.5 264.5C275.8 259.8 268.2 259.8 263.5 264.5L176 352 136.5 312.5C131.8 307.8 124.2 307.8 119.5 312.5L80 352V416zM128 176C101.5 176 80 197.5 80 224S101.5 272 128 272 176 250.5 176 224 154.5 176 128 176z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/file-image.js
// module id = 1O+S
// module chunks = 144